// extracted by css-extract-rspack-plugin
module.exports =  {"root":"JobsListEmpty__root___TDvWG"};